import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/apps/products/')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login' });
    }
    // Redirect to existing products page
    throw redirect({ to: '/products' });
  },
});
